module.exports = __webpack_public_path__ + "static/cover-e4fef32d7a2a2634fd7e22d7855ec232.gif";